import { prefetchPlayResource } from "@/features/play/records";
import { ProductRouteError } from "@/session/product-route-frame";
import { createFileRoute } from "@tanstack/react-router";
import { PlayEpisodesPage, PlayPending } from "@/features/play";

export const Route = createFileRoute("/_site/$coworld/$league/play_/episodes")({
  loader: ({ context, location }) => {
    prefetchPlayResource({
      client: context.queryClient,
      href: location.href,
      resource: "episodes",
    });
  },
  pendingComponent: PlayPending,
  errorComponent: ProductRouteError,
  head: () => ({
    meta: [
      { title: "Episodes · Softmax" },
      { name: "robots", content: "noindex, follow" },
    ],
  }),
  component: PlayEpisodesPage,
});
